import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Baby } from "lucide-react";
import { nearlabPricing } from "@/data/serviceData";
const GenderRevealPricingTable = () => {
  console.log('GenderRevealPricingTable rendering with updated pricing data');
  const genderRevealTests = [{
    name: "Peekaboo Early Gender Test",
    description: "Determine baby's gender as early as 6 weeks with 99.9% accuracy",
    price: nearlabPricing.genderReveal.earlyPeekaboo.price,
    time: nearlabPricing.genderReveal.earlyPeekaboo.time
  }, {
    name: "Peekaboo Rush Results",
    description: "Get your gender results in just 1-2 business days",
    price: nearlabPricing.genderReveal.rushPeekaboo.price,
    time: nearlabPricing.genderReveal.rushPeekaboo.time
  }];
  return (
    <Card className="w-full">
      <CardHeader className="bg-gradient-to-r from-pink-50 to-blue-50 border-b">
        <div className="flex items-center justify-center gap-3">
          <Baby className="h-6 w-6 text-pink-600" />
          <CardTitle className="text-2xl text-center">Gender Reveal Testing Prices</CardTitle>
          <Baby className="h-6 w-6 text-blue-600" />
        </div>
        <p className="text-center text-gray-600 mt-2">
          Professional gender determination testing with mobile service included
        </p>
      </CardHeader>
      <CardContent className="p-8">
        <div className="grid gap-6 md:grid-cols-2">
          {genderRevealTests.map((test, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow bg-gradient-to-br from-white to-gray-50"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-lg text-gray-900">{test.name}</h3>
                <Badge 
                  variant="secondary" 
                  className={`${
                    index === 1 ? 'bg-pink-100 text-pink-800' : 
                    index === 2 ? 'bg-blue-100 text-blue-800' : 
                    'bg-gray-100 text-gray-800'
                  }`}
                >
                  {test.time}
                </Badge>
              </div>
              <p className="text-gray-600 mb-4 text-sm">{test.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-2xl font-bold text-gray-900">${test.price}</span>
                <div className="text-right">
                  <div className="text-sm text-gray-500">Starting at</div>
                  <div className="text-xs text-gray-400">Mobile service included</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600 mb-4">
            All tests include mobile collection service, secure result delivery, and customer support.
          </p>
          <Badge variant="outline" className="bg-gradient-to-r from-pink-50 to-blue-50 border-pink-200">
            99.9% Accuracy Guaranteed • AABB Accredited Lab
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
};
export default GenderRevealPricingTable;